module.exports = __webpack_public_path__ + "static/img/home_culture_03.1760733.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/ter/images/home_culture_03.png
// module id = VUqs
// module chunks = 0